<article
  #cardElement
  class="fz-game-card"
  [ngClass]="{
    'fz-game-card__life-experience': tournament?.lifeExperience === true,
    'fz-game-card__casual': tournament?.lifeExperience !== true,
    'fz-game-card__extended': isExtended,
    'fz-game-card__opened': opened,
    'fz-game-card__hovered': hovered
  }"
>
  <button
    mat-icon-button
    class="fz-game-card__close-preview touchable-area"
    (click)="onClosePreview($event)"
  >
    <mat-icon>close</mat-icon>
  </button>

  <div class="fz-game-card__section fz-game-card__top-section">
    <div class="fz-game-card__top-section__root">
      <!-- game shared action -->
      <div
        class="fz-game-card__shared-button touchable-area"
        (click)="handleShare($event)"
      >
        <button
          #shareButton
          mat-raised-button
          class="mat-shared-icon"
          data-ga-value="game-card-share-button"
          color="accent"
        >
          <mat-icon>share</mat-icon>
        </button>
      </div>

      <!-- game tag -->
      <div class="fz-game-card__tag" *ngIf="!opened">
        <fz-card-status
          *ngIf="tournament"
          [tournament]="tournament"
        ></fz-card-status>
      </div>
    </div>
  </div>

  <div class="fz-game-card__root">
    <fz-game-card-image [image]="getBackgroundImageUrl"> </fz-game-card-image>

    <div class="fz-game-card__body">
      <!-- Game Card Header -->
      <div class="fz-game-card__header">
        <div class="fz-game-card__header__root">
          <div
            class="fz-game-card__header__game-avatar"
            [ngStyle]="{
              backgroundImage:
                'url(' + getGameImageUrl + '), url(/shared/img/all-sports.webp)'
            }"
          >
            <picture>
              <img
                loading="lazy"
                class="game-image"
                alt="Game image"
                [src]="getGameImageUrl"
                fzSrcError="/shared/img/all-sports.webp"
              />
            </picture>
          </div>
          <div class="fz-game-card__header__tournament-name">
            <div class="">
              {{ tournament?.name }}
            </div>
            <!-- Time -->
            <ng-content
              select="fz-game-card-time, [fz-game-card-time], [fzGameCardTime]"
              *ngIf="opened"
            ></ng-content>
          </div>
        </div>
      </div>

      <div class="fz-game-card__content">
        <div class="fz-game-card__content__root">
          <div class="game-card__number" *ngIf="isEvent">
            <ng-content
              select="fz-game-card-number, [fz-game-card-number], [fzGameCardRoomNumber]"
            >
            </ng-content>
          </div>

          <div class="game-card__extra" *ngIf="!disableExtraData">
            <ng-content></ng-content>
          </div>

          <!-- Prize -->
          <ng-content
            select="fz-game-card-prize, [fz-game-card-prize], [fzGameCardPrize]"
          ></ng-content>

          <ng-content
            select="fz-game-card-details, [fz-game-card-details], [fzGameCardRoomDetails]"
          ></ng-content>

          <ng-content
            select="fz-game-card-prize-description, [fz-game-card-prize-description], [fzGameCardPrizeDescription]"
          ></ng-content>

          <!-- Description -->
          <ng-content
            select="fz-game-card-description, [fz-game-card-description], [fzGameCardDescription]"
          ></ng-content>

          <!-- Type -->
          <ng-content
            select="fz-game-card-tags, [fz-game-card-tags], [fzGameCardTags]"
          ></ng-content>

          <!-- Show action based on tournament status -->
          <div class="fz-game-card__actions">
            <button mat-flat-button color="primary">
              <span>{{ actionText }}</span> <mat-icon>open_in_new</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div
        class="fz-game-card__open-preview touchable-area"
        (click)="onOpenPreview($event)"
      >
        <ng-container *ngTemplateOutlet="iconOpenPreview"></ng-container>
      </div>
    </div>
  </div>
</article>

<!-- Icon: Open Preview  -->
<ng-template #iconOpenPreview>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="none"
    class="fz-game-card__open-preview__icon"
  >
    <path
      d="M31 1.90735e-06L0 31H31V1.90735e-06Z"
      fill="url(#paint0_linear_3522_43673)"
    />
    <mask
      id="mask0_3522_43673"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="31"
      height="31"
    >
      <path
        d="M31 1.90735e-06L0 31H31V1.90735e-06Z"
        fill="url(#paint1_linear_3522_43673)"
      />
    </mask>
    <g mask="url(#mask0_3522_43673)">
      <path
        d="M7.5 21H22.5V19.3333H7.5V21ZM7.5 16.8333H22.5V15.1667H7.5V16.8333ZM7.5 11V12.6667H22.5V11H7.5Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3522_43673"
        x1="21.9192"
        y1="21.6061"
        x2="15.6566"
        y2="15.3434"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF7D26" />
        <stop offset="1" stop-color="#CA5100" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3522_43673"
        x1="21.9192"
        y1="21.6061"
        x2="15.6566"
        y2="15.3434"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF7D26" />
        <stop offset="1" stop-color="#CA5100" />
      </linearGradient>
    </defs>
  </svg>
</ng-template>

<!-- Icon: Close Preview -->
<ng-template #iconClosePreview>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path opacity="0.4" d="M48 48L0 0H48V48Z" fill="#121212" />
  </svg>
  <mat-icon>close</mat-icon>
</ng-template>
